export default "__VITE_ASSET__DT6Q9kWl__"